import PC from './pc';
import H5 from './h5';

export interface Props extends React.HTMLAttributes<HTMLDivElement> {}

export default isMobile || isPad ? H5 : PC;
